import type { ReactNode } from 'react';

interface SessionBoardFiltersProps {
  children: ReactNode;
}

/** Shared filter panel styling for session board and session cards pages. */
export function SessionBoardFilters({ children }: SessionBoardFiltersProps) {
  return (
    <div
      className="bg-white p-4 mb-6"
      style={{ borderRadius: '16px', border: '1px solid rgba(0,0,0,0.08)' }}
    >
      {children}
    </div>
  );
}

interface FilterToggleButtonProps {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  ariaLabel: string;
}

export function FilterToggleButton({ active, onClick, children, ariaLabel }: FilterToggleButtonProps) {
  return (
    <button
      type="button"
      className={`btn btn-sm ${active ? 'btn-primary' : 'btn-secondary'}`}
      onClick={onClick}
      aria-pressed={active}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}

interface ClearFiltersButtonProps {
  onClick: () => void;
  className?: string;
}

export function ClearFiltersButton({ onClick, className = '' }: ClearFiltersButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`btn btn-sm btn-secondary ${className}`.trim()}
    >
      Clear filters
    </button>
  );
}

interface NoResultsMessageProps {
  hasItems: boolean;
  emptyMessage: string;
  filteredMessage: string;
  onClearFilters?: () => void;
}

export function NoResultsMessage({
  hasItems,
  emptyMessage,
  filteredMessage,
  onClearFilters,
}: NoResultsMessageProps) {
  return (
    <div className="text-center py-12 rounded-lg" style={{ background: '#FFFDF5' }}>
      <p className="text-gray-500">{hasItems ? filteredMessage : emptyMessage}</p>
      {hasItems && onClearFilters && (
        <ClearFiltersButton onClick={onClearFilters} className="mt-4" />
      )}
    </div>
  );
}
